module.exports = __webpack_public_path__ + "images/ff4c53bf05bb2050da26d0941159b431-costa rica.png";